
import React, { useEffect } from 'react';
import { useAuth } from '@/contexts/AuthContext';

// Declare the custom element type for TypeScript
declare global {
  namespace JSX {
    interface IntrinsicElements {
      'stripe-buy-button': {
        'buy-button-id': string;
        'publishable-key': string;
        'customer-email'?: string;
      };
    }
  }
}

// Updated with your actual buy button IDs
const MONTHLY_BUY_BUTTON_ID = 'buy_btn_1RbPhRKcjOIx3YMhoCJ90rPy';
const YEARLY_BUY_BUTTON_ID = 'buy_btn_1RbPeYKcjOIx3YMhyPnxdCoO';

export const StripeEmbeddedButton: React.FC = () => {
  const { user } = useAuth();

  const yearlySavings = 100;

  // Load Stripe script
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://js.stripe.com/v3/buy-button.js';
    script.async = true;
    document.head.appendChild(script);

    return () => {
      // Cleanup script on unmount
      const existingScript = document.querySelector('script[src="https://js.stripe.com/v3/buy-button.js"]');
      if (existingScript) {
        document.head.removeChild(existingScript);
      }
    };
  }, []);

  return (
    <div className="space-y-6">
      <div className="space-y-4">
        <div className="space-y-3">
          <p className="text-center font-semibold text-lg text-gray-900">
            Choose Your Billing Frequency
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {/* Monthly Premium Button */}
            <div className="flex flex-col items-center space-y-3">
              <stripe-buy-button
                buy-button-id={MONTHLY_BUY_BUTTON_ID}
                publishable-key="pk_live_51RZsmRKcjOIx3YMh0JmAViuzRy2yS4H5Yzipw1vgApnVFWOyvpQfSkVQfJNXSqKJtuSx6yhKIzV64mn2D81EGniv00y068XZm4"
                customer-email={user?.email || undefined}
              />
            </div>

            {/* Yearly Premium Button */}
            <div className="flex flex-col items-center space-y-3">
              <stripe-buy-button
                buy-button-id={YEARLY_BUY_BUTTON_ID}
                publishable-key="pk_live_51RZsmRKcjOIx3YMh0JmAViuzRy2yS4H5Yzipw1vgApnVFWOyvpQfSkVQfJNXSqKJtuSx6yhKIzV64mn2D81EGniv00y068XZm4"
                customer-email={user?.email || undefined}
              />
              <p className="text-green-600 font-medium text-sm">Save ${yearlySavings}!</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
